<div class="row">
  <div class="col-12 pl-4">
    <!-- <div class="btn-group mr-2">
        <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'POJEDINACNAEVIDENCIJA.SENDEUINVOICE.ACTION'" [Container]="'body'" 
            (clicked)="SendEUInvoice(baseUpdate.Item)" 
            [IsDisabled]="baseUpdate.Item.ID==-1 || loadingSendEUInvoice"
            [Model]="'pojedinacnaevidencijapdv'" [Action]="'Upload_XML_Sef_PojedinacnaEvidencija'">
            <i class="fas fa-file-export"></i>
            <span *ngIf="loadingSendEUInvoice" class="loader"><span class="fa fa-spinner fa-spin"></span></span> 
        </yt-button> 
    </div>

    <div class="btn-group mr-2">
        <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'POJEDINACNAEVIDENCIJA.OSVEZISTATUS.ACTION'" [Container]="'body'"
            [NgStyle]="{'background-color':bojaStatusa}"
            [IsDisabled]="baseUpdate.Item.ID==-1"                 
            (clicked)="RefreshStatusClick()"                     
            [Model]="'pojedinacnaevidencijapdv'" [Action]="'Upload_XML_Sef_PojedinacnaEvidencija'">
            <i class="fas fa-sync-alt"></i>
            <span *ngIf="loadingEUInvoiceStatus" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
        </yt-button>
    </div> -->

       <yt-fw-default-update-buttons #defaultUpdateButtons>
        <div class="mr-2">
            <h2 style="display:inline-block; color: #71b1d1">
                <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="POJEDINACNAEVIDENCIJAPDV.NEW"></span></span>

                <span *ngIf="baseUpdate.Item.ID > 0">
                    <!-- <span translate="FAKDOKUMENT.BRDOK.SINGULAR"></span> -->
                    <span><span translate="POJEDINACNAEVIDENCIJAPDV.EDIT"></span></span>

                    <span style="padding-left: 5px">{{baseUpdate.Item.BrojObracuna}}</span>
                </span>
            </h2>
        </div>


        <!-- <div class="btn-group mr-2" *ngIf="!((baseUpdate.Item.Godina>=2024 && baseUpdate.Item.PoreskiPeriodId==1 && baseUpdate.Item.PeriodId>=9)
            || (baseUpdate.Item.Godina>=2024 && baseUpdate.Item.PoreskiPeriodId==2 && baseUpdate.Item.PeriodId==16)
            || baseUpdate.Item.Godina>2024)">
            <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'POJEDINACNAEVIDENCIJAPDV.SENDEUINVOICE.ACTION'" [Container]="'body'" 
                (clicked)="SendIndividualVatRecording(baseUpdate.Item)" 
                [IsDisabled]="baseUpdate.Item.ID==-1 || loadingSendEUInvoice"
                [Model]="'pojedinacnaevidencijapdv'" [Action]="'Upload_XML_Sef_PojedinacnaEvidencija'">
                <i class="fas fa-file-export"></i>
                <span *ngIf="loadingSendEUInvoice" class="loader"><span class="fa fa-spinner fa-spin"></span></span> 
            </yt-button> 
        </div>
    
       

        <div class="btn-group mr-2" *ngIf="!((baseUpdate.Item.Godina>=2024 && baseUpdate.Item.PoreskiPeriodId==1 && baseUpdate.Item.PeriodId>=9)
            || (baseUpdate.Item.Godina>=2024 && baseUpdate.Item.PoreskiPeriodId==2 && baseUpdate.Item.PeriodId==16)
            || baseUpdate.Item.Godina>2024)">
            <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'POJEDINACNAEVIDENCIJAPDV.OSVEZISTATUS.ACTION'" [Container]="'body'"
                [NgStyle]="{'background-color':bojaStatusa}"
                [IsDisabled]="baseUpdate.Item.ID==-1"                 
                (clicked)="RefreshStatusClick()"                     
                [Model]="'pojedinacnaevidencijapdv'" [Action]="'Upload_XML_Sef_PojedinacnaEvidencija'">
                <i class="fas fa-sync-alt"></i>
                <span *ngIf="loadingEUInvoiceStatus" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
            </yt-button>
        </div>
    
        <div class="btn-group mr-2" *ngIf="((baseUpdate.Item.Godina>=2024 && baseUpdate.Item.PoreskiPeriodId==1 && baseUpdate.Item.PeriodId>=9)
            || (baseUpdate.Item.Godina>=2024 && baseUpdate.Item.PoreskiPeriodId==2 && baseUpdate.Item.PeriodId==16)
            || baseUpdate.Item.Godina>2024)">
            <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'POJEDINACNAEVIDENCIJAPDV.SENDEUINVOICE.ACTION'" [Container]="'body'" 
                (clicked)="SendIndividualVatRecordingV2(baseUpdate.Item)" 
                [IsDisabled]="baseUpdate.Item.ID==-1 || loadingSendEUInvoiceV2"
                [Model]="'pojedinacnaevidencijapdv'" [Action]="'Upload_XML_Sef_PojedinacnaEvidencija'">
                <i class="fas fa-file-export"></i>
                <span *ngIf="loadingSendEUInvoiceV2" class="loader"><span class="fa fa-spinner fa-spin"></span></span> 
            </yt-button> 
        </div>
        
        <div class="btn-group mr-2" *ngIf="((baseUpdate.Item.Godina>=2024 && baseUpdate.Item.PoreskiPeriodId==1 && baseUpdate.Item.PeriodId>=9)
            || (baseUpdate.Item.Godina>=2024 && baseUpdate.Item.PoreskiPeriodId==2 && baseUpdate.Item.PeriodId==16)
            || baseUpdate.Item.Godina>2024)">
            <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'POJEDINACNAEVIDENCIJAPDV.OSVEZISTATUS.ACTION'" [Container]="'body'"
                [NgStyle]="{'background-color':bojaStatusa}"
                [IsDisabled]="baseUpdate.Item.ID==-1"                 
                (clicked)="RefreshStatusV2Click()"                     
                [Model]="'pojedinacnaevidencijapdv'" [Action]="'Upload_XML_Sef_PojedinacnaEvidencija'">
                <i class="fas fa-sync-alt"></i>
                <span *ngIf="loadingEUInvoiceStatusV2" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
            </yt-button>
        </div> -->

        <div class="btn-group mr-2" >
            <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'POJEDINACNAEVIDENCIJAPDV.SENDEUINVOICE.ACTION'" [Container]="'body'" 
                (clicked)="SendIndividualVatRecordingV1OrV2(baseUpdate.Item)" 
                [IsDisabled]="baseUpdate.Item.ID==-1 || loadingSendEUInvoiceV2 || !baseUpdate.Item.Editable"
                [Model]="'pojedinacnaevidencijapdv'" [Action]="'Upload_XML_Sef_PojedinacnaEvidencija'">
                <i class="fas fa-file-export"></i>
                <span *ngIf="loadingSendEUInvoiceV1OrV2" class="loader"><span class="fa fa-spinner fa-spin"></span></span> 
            </yt-button> 
        </div>
        
        <div class="btn-group mr-2" >
            <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'POJEDINACNAEVIDENCIJAPDV.OSVEZISTATUS.ACTION'" [Container]="'body'"
                [NgStyle]="{'background-color':bojaStatusa}"
                [IsDisabled]="baseUpdate.Item.ID==-1 || !baseUpdate.Item.Editable"                 
                (clicked)="RefreshStatusV1OrV2Click()"                     
                [Model]="'pojedinacnaevidencijapdv'" [Action]="'Upload_XML_Sef_PojedinacnaEvidencija'">
                <i class="fas fa-sync-alt"></i>
                <span *ngIf="loadingIndividualVatStatusV1OrV2" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
            </yt-button>
        </div>

        <div style="padding-left: 5px; margin-right: 25px; margin-top: 10px;color: #71b1d1;">
             <span *ngIf="baseUpdate.Item.StatusTooltip"
                text-align="center" 
                [translate]="baseUpdate.Item.StatusTooltip">
             </span>
        </div>
      </yt-fw-default-update-buttons> 

        




  </div>

</div>
<yt-pojedinacna-evidencija-pdv-update #baseUpdate (ColorEmiter)="ColorChange($event)"></yt-pojedinacna-evidencija-pdv-update>